// 导入封装好的网络请求类工具
import service from "./axios";

// 获取我的报考
export const getMyApply = () => {
  return service({
    url: "/apply/applyDetail/getAllPersonApplyDetailList",
    method: "post",
    data: {},
    code: "v4"
  });
};

// 考生信息修改
export const updataUserInfo = (data) => {
  return service({
    url: "/apply/applyInfo/update",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取我的考试
export const getMyExam = () => {
  return service({
    url: "/apply/applyDetail/getDoingApplyDetailList",
    method: "post",
    data: {},
    code: "v4"
  });
};



// WEBPACK FOOTER //
// ./src/api/personal.js